import React from 'react';
import { Table } from 'antd';

import { TableCol } from './getTableCol';

import { courseStruct } from './struct';
import { semesterLabel } from '../../../../../../../const/semesterLabel';

const { table } = courseStruct;

export const Course = ({ courses, apaPoint, semesterName, status }) => {


  const columns = [
    ...TableCol(status),
    {
      title: 'Action',
      dataIndex: 'operation'
      
    }
  ];



  return courses?.length > 0 ? (
    <>
      <Table
        {...table}
        columns={columns}
        dataSource={courses}
        summary={() => (
          <Table.Summary.Row>
            <Table.Summary.Cell colSpan={columns.length - 2} align='right' >
              Calculated APA score for the {semesterLabel(semesterName)} semester:
            </Table.Summary.Cell>
            <Table.Summary.Cell colSpan={2}>{apaPoint}</Table.Summary.Cell>
          </Table.Summary.Row>
        )}
      />
      <br />

    </>
  ) : (
    <></>
  );
};
